
import { Prop } from 'vue-property-decorator';
import * as OM from '@/Model';
import { Options, Vue } from 'vue-class-component';
import * as VM from '@/viewModel';
import { BaseUserClient, LeadClient } from '@/services/Services';
import { LeadServices } from '@/services/LeadServices';
import EventBus from '@/services/EventBus';

@Options({})
export default class note extends Vue {

    @Prop() user: OM.Lead;
    @Prop() readonly: boolean;

    addNota(vm: VM.AddCommentEvent){
        LeadServices.AddNota({
            allegati: vm.fileList,
            text: vm.text,
            entityIdentifier: this.user.identifier
        })
        .then(x => {
            this.user.note.unshift(x);
            window.toastr.success("Salvato!");
            EventBus.$emit('newcomment');
        })
    }

    onDeleteComment(item: OM.Comment){
        if(!confirm("Confermi la rimozione?")){
            return;
        }
        
        LeadClient.removeComment(item.identifier, this.user.identifier)
        .then(x => {
            let index = this.user.note.findIndex(x => x.identifier == item.identifier);
            this.user.note.splice(index, 1);
        })
    }

}
